// Expoe o jQuery globalmente ANTES de qualquer plugin/codigo legado.
// Importado como primeiro modulo do vendor.js: por ser uma dependencia
// separada, executa antes dos imports seguintes (ordem depth-first do esbuild),
// garantindo window.jQuery para plugins que leem o global no carregamento
// (ex.: jquery-ujs).
import jQuery from "jquery";

window.jQuery = window.$ = jQuery;

export default jQuery;
